import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RsbLookupModel } from 'src/app/common/model/rsb-lookup.model';
import { RsbService } from 'src/app/service/rsb.service';
@Component({
  selector: 'app-assign-subfranchise',
  templateUrl: './assign-subfranchise.component.html',
  styleUrls: ['./assign-subfranchise.component.css']
})
export class AssignSubfranchiseComponent implements OnInit {
  userTypeName: string = '';
  allStaffRecords:Array<any> = [];
  constructor(public rsbLookup: RsbLookupModel,
    private rsbService: RsbService,
    private router: Router,
    public activeModal: NgbActiveModal
  ) { }


  ngOnInit(): void {
    this.getSubFranchise()
  }

  getSubFranchise(): void {
    this.rsbService.getStaffDataWithoutPagination('subfranchise').subscribe((rsp) => {
      if(rsp.statusCode === 0 && rsp.contents.length > 0) {
        this.allStaffRecords = rsp.contents
      }
    })
  }

  assign(record:any): void {
    this.activeModal.close(record);

  }

}
